import React, { useState } from 'react'
import { HiMiniPlus, HiOutlineTrash } from 'react-icons/hi2'

const TodoListInput = ({ setTodoList, todoList }) => {
  const [option, setOption] = useState('')
  // Ajouter une tâche
  const handleAddOption = () => {
  if (option.trim() !== '') {
    setTodoList([
      ...todoList,
      { text: option.trim(), completed: false } 
    ]);
    setOption('');
  }
};

  // Supprimer une tâche
  const handleDeleteOption = (index) => {
    const updatedArr = todoList.filter((_, idx) => idx !== index)
    setTodoList(updatedArr)
  }

  return (
    <div>
      {todoList.map((item, index) => (
        <div
          key={index}
          className="flex justify-between bg-gray-50 border border-gray-100 px-3 py-2 rounded-md mb-3 mt-2 "
        >
          <p className="text-xs text-black">
            <span className="text-xs text-gray-400 font-semibold ">
              {index < 9 ? `0${index + 1}` : index + 1}.
            </span>{' '}
            {item.text} {/* <- On affiche text au lieu de l'objet entier */}
          </p>
          <button
            type="button"
            onClick={() => handleDeleteOption(index)}
            className="cursor-pointer"
          >
            <HiOutlineTrash className="text-lg text-red-500" />
          </button>
        </div>
      ))}
      <div className="flex items-center gap-5 mt-4">
        <input
          type="text"
          placeholder="Ajouter des consignes"
          value={option}
          onChange={(e) => setOption(e.target.value)}
          className="w-full text-[13px] text-black outline-none bg-white border border-gray-100 px-3 py-2 rounded-md"
        />
        <button type="button" onClick={handleAddOption} className="card-btn text-nowrap">
          <HiMiniPlus className="text-lg" />
        </button>
      </div>
    </div>
  )
}

export default TodoListInput
